module.exports = __webpack_public_path__ + "static/media/bonafind.2d9c48cb.png";